module.exports = __webpack_public_path__ + "assets/GeometricMeanDetailed.b479ca3f97a7982b390cba0d00b27fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/GeometricMeanDetailed.png
// module id = 515
// module chunks = 0